import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
	name: string;
	roleCapabilities:any;
}

const initialState: IState = {
	name: "",
	roleCapabilities:[]
};

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		nameUpdate: (state: any, action: PayloadAction<string>) => {
			state.name = action.payload;
		},
		assignCapabilities: (state: any, action) => {
			state.roleCapabilities = action.payload
		  },
	},
});

// Action creators are generated for each case reducer function
export const { nameUpdate,assignCapabilities } = userSlice.actions;

export default userSlice.reducer;
